import { cn } from '@/lib/utils';
import { useT } from '@/i18n/use-t';
import { useTheme } from '@/theme/use-theme';

type BrandLogoProps = {
  className?: string;
  /** Visual height in px. Defaults match design-doc §9.1. */
  height?: number;
  /** Override theme detection (rare; used by login page on dark backgrounds). */
  variant?: 'light-bg' | 'dark-bg';
};

/**
 * BOS lockup with the signature coral bar between `re` and `form`.
 * Swaps the navy + inverted variants by theme so the wordmark stays
 * legible on every surface register. See design-language.md §9.
 */
export function BrandLogo({ className, height = 36, variant }: BrandLogoProps) {
  const { mode } = useTheme();
  const t = useT('admin_ui');
  const resolvedVariant: 'light-bg' | 'dark-bg' =
    variant ?? (mode === 'dark' ? 'dark-bg' : 'light-bg');
  const src =
    resolvedVariant === 'dark-bg'
      ? '/brand/reform-lite-bos-inverted.svg'
      : '/brand/reform-lite-bos.svg';

  return (
    <img
      src={src}
      alt={t('shell.logoAlt', 're:form.lite Backoffice')}
      style={{ height }}
      className={cn('select-none', className)}
      draggable={false}
    />
  );
}
